<mat-card>
  <mat-card-title fxLayout="row">
    <div fxFlex>Administrador de productos</div>
    <mat-slide-toggle [checked]="this.viewOnlyActive" (change)="changeOnlyActive()">Ver Sólo Activos</mat-slide-toggle>
  </mat-card-title>
  <mat-card-content>
    <div *ngIf="dataSource.loading$ | async">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <mat-table [dataSource]="dataSource" matSort matSortActive="productCode" matSortDirection="asc" matSortDisableClear>
      <ng-container matColumnDef="productCode">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Id de producto </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.productCode}} </mat-cell>
      </ng-container>
      <!-- <ng-container matColumnDef="productCode">
        <mat-header-cell *matHeaderCellDef> Código </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.productCode}} </mat-cell>
      </ng-container> -->
      <ng-container matColumnDef="productDescription">
        <mat-header-cell *matHeaderCellDef> Descripción </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.productDescription}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Estado </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.status}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="isPrintable">
        <mat-header-cell *matHeaderCellDef mat-sort-header> ¿Se imprime? </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.isPrintable ? 'Si' : '' }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="updated">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Actualización </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.updated | date: 'yyyy/MM/dd HH:mm:ss'}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="updatedBy">
        <mat-header-cell *matHeaderCellDef> Actualizado por </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.updatedBy}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>
          <a routerLink="/administrador/productos/nuevo" matTooltip="Nuevo" mat-icon-button>
            <mat-icon>add</mat-icon>
          </a>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-icon-button routerLink="/administrador/productos/{{element.productCode}}" matTooltip="Editar" color="primary">
            <mat-icon aria-label="Editar">edit</mat-icon>
          </a>
          <!-- <button mat-icon-button color="warn" matTooltip="Eliminar" (click)="deleteProduct(element)"  *ngIf="element.status === 'A'">
              <mat-icon aria-label="Eliminar">delete</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="Restaurar" (click)="restoreProduct(element)" *ngIf="element.status !== 'A'">
              <mat-icon aria-label="Restaurar">restore</mat-icon>
          </button> -->
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"> </mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator [length]="dataSource.count" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
  </mat-card-content>
</mat-card>
